import { runBotDetection } from '@/common/autoTests';

const state = () => ({});

// getters
const getters = {};

// actions
const actions = {
  async runAutoTests() {
    console.log('Running auto tests...');
    let check = runBotDetection();
    if (check !== false) {
      /* eslint-disable-next-line */
      try {
        console.log(check);
        console.log("Please disable all bots per our website's requirements.");
        throw check;
      } catch (e) {
        throw e;
      }
    }
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
